import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@mui/material';
export default function RouteDriverEditor({ proposal, editable, request, onChange }) {
    const mounted = useRef(true);
    useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
    const [open, setOpen] = useState(false);
    const [drivers, setDrivers] = useState([]);
    const [driverId, setDriverId] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [review, setReview] = useState(null);
    const external = proposal.status === 'submitted';
    const currentId = review?.current_driver_id ?? proposal.driver_id;
    const begin = async () => {
        setOpen(true); setBusy(true); setError(''); setDrivers([]); setDriverId(''); setReview(null);
        try {
            const response = await request('get', '/driver');
            if (!mounted.current) return;
            const result = response.data.data;
            const options = Array.isArray(result) ? result : result.drivers;
            setReview(Array.isArray(result) ? null : result);
            const assigned = result.current_driver_id ?? proposal.driver_id;
            setDrivers(options);
            setDriverId(options.some(row => row.id === assigned) ? String(assigned) : '');
        } catch (failure) { if (mounted.current) setError(failure.response?.data?.message || 'No se pudo consultar los conductores de Parlevel. Cierre y vuelva a intentar.'); }
        finally { if (mounted.current) setBusy(false); }
    };
    const save = async () => {
        setBusy(true); setError('');
        try {
            const response = await request('patch', '/driver', { version: review?.proposal_version ?? proposal.version, driver_id: Number(driverId), ...(external ? { fingerprint: review?.fingerprint } : {}) });
            if (mounted.current) { setOpen(false); onChange(response.data.data); }
        } catch (failure) { if (mounted.current) setError(failure.response?.data?.message || 'No se pudo guardar el conductor. Actualice y vuelva a intentar.'); }
        finally { if (mounted.current) setBusy(false); }
    };
    return <>
        <Button size="small" disabled={!editable || busy} onClick={begin}>Cambiar conductor</Button>
        <Dialog open={open} onClose={() => { if (!busy) setOpen(false); }} fullWidth maxWidth="sm">
            <DialogTitle>Cambiar conductor</DialogTitle>
            <DialogContent>
                <Typography sx={{ mb: 2 }}>{external ? 'Guardar actualizará el conductor de este servicio en Parlevel. No crea una ruta nueva.' : 'El conductor se guardará para esta propuesta y se asignará al enviar la ruta a Parlevel.'}</Typography>
                {external && review && <Typography variant="body2" sx={{ mb: 2 }}>Servicio #{review.service_id} · {review.service_date}</Typography>}
                {review?.pending && <Alert severity="warning" sx={{ mb: 2 }}>Hay un cambio pendiente de verificar. Cierre y vuelva a comprobar antes de realizar otro cambio.</Alert>}
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                {busy && <Typography role="status">Consultando o guardando…</Typography>}
                <TextField select fullWidth label="Conductor" value={driverId} disabled={busy} onChange={event => setDriverId(event.target.value)}>
                    <MenuItem value="">Seleccione un conductor</MenuItem>
                    {drivers.map(driver => <MenuItem key={driver.id} value={String(driver.id)}>{driver.name}</MenuItem>)}
                </TextField>
                {!busy && !error && !drivers.length && <Alert severity="info">Parlevel no devolvió conductores disponibles.</Alert>}
            </DialogContent>
            <DialogActions><Button disabled={busy} onClick={() => setOpen(false)}>Cancelar</Button><Button variant="contained" disabled={busy || !driverId || !!review?.pending || Number(driverId) === currentId} onClick={save}>Guardar conductor</Button></DialogActions>
        </Dialog>
    </>;
}
